import { render, staticRenderFns } from "./Uniview.vue?vue&type=template&id=73a9e8e6"
import script from "./Uniview.vue?vue&type=script&lang=js"
export * from "./Uniview.vue?vue&type=script&lang=js"
import style0 from "./Uniview.vue?vue&type=style&index=0&id=73a9e8e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_85bb6ef93cf5a779f9b064f420832c70/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports